import React, { useState, useEffect } from 'react'

// import LazyLoad from 'react-lazy-load'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { Redirect, useParams } from 'react-router-dom'
import styled from 'styled-components'

import { SimpleCarousel } from '.'
import { setMenuTrace } from '../../_actions'
import { useWindowSize } from '../../_helpers'
import {
    Container,
    Meta,
    Title,
    devices,
    // colors,
} from '../Common'
import { Loading } from '../Global/Loading'

const ImageCard = ({ image, openModal }) => (
    // <ImageContainer>
    <img src={image.image} alt={image.alt_text} onClick={openModal} />
    // </ImageContainer>
)


const PageView = () => {
    const { page, notFound } = useSelector(state => state.content, shallowEqual)
    const { gallery, title } = page
    const dispatch = useDispatch()
    const [showLightBox, setShowLightBox] = useState(false)
    const [activeSlide, setactiveSlide] = useState(0)
    const { width } = useWindowSize()
    const { slug1, slug2, slug3, slug4, slug5, slug6, slug7, slug8 } = useParams()
    const breadCrumbs = [
        slug1 && slug1,
        slug2 && slug2,
        slug3 && slug3,
        slug4 && slug4,
        slug5 && slug5,
        slug6 && slug6,
        slug7 && slug7,
        slug8 && slug8,
    ].filter(e => e)
    const mobile = width < 480

    const openMenu = trace => () => dispatch(setMenuTrace(trace))

    if (notFound) return <Redirect to='/' />

    const openModal = i => {
        setactiveSlide(i)
        window.scrollTo(0, 0)
        setShowLightBox(true)
    }

    const closeModal = () => setShowLightBox(false)

    useEffect(closeModal, [page])

    return (
        <>
            <Meta page={page} />
            <PageContainer lightbox={showLightBox}>
                {title &&
                    <Menu>
                        {breadCrumbs.map((m, i) =>
                            <BreadCrumb
                                key={`${i}-${m}`}
                                onClick={i !== breadCrumbs.length - 1 ? openMenu(breadCrumbs.slice(0, i + 1)) : () => { }}
                                fontSize={mobile ? 14 : 16}
                                clickable={i !== breadCrumbs.length - 1}
                            >
                                {i === breadCrumbs.length - 1 ? title : m.replace(/-/g, ' ')}{i < breadCrumbs.length - 1 && <BreadCrumbBreak>&gt;</BreadCrumbBreak>}
                            </BreadCrumb>
                        )}
                    </Menu>
                }
                {gallery ?
                    showLightBox ?
                        <SimpleCarousel slides={gallery} close={closeModal} activeImage={activeSlide} mobile={mobile} />
                        :
                        <>
                            <ImageList>
                                {gallery.map((image, i) => <ImageCard key={i} image={image} openModal={() => openModal(i)} />)}
                            </ImageList>
                        </>
                    : <Loading marginbottom={30} />}
            </PageContainer>
        </>
    )
}

const PageContainer = styled(Container)`
    ${({ lightbox }) => lightbox && `
        padding-left: 0;
        padding-right: 0;
    `}

    min-height: calc(100vh - 90px);
    @media ${devices.small} {
        min-height: 95vh;
    }
`

const ImageList = styled.div`
   column-count: 3;
   column-gap: 6px;

    img {
        width: 96%;
        height: auto;
        border: 7px solid white;
        cursor: pointer;
        margin-bottom: 6px;
    }

    @media ${devices.small} {
        column-count: 2;
        column-gap: 6px;

        img {
            border-width: 3px;
        }
    }
`

// const ImageContainer = styled.div`
//     @media ${devices.small} {

//     }
// `

const Menu = styled.div`

`

const BreadCrumb = styled(Title)`
    display: inline-block;
    ${({ clickable }) => clickable ? `
        cursor: pointer;
        opacity: 0.26;
    ` : ''}
`

const BreadCrumbBreak = styled.span`
    padding: 0 10px;
`

export default PageView
